(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("scoreExam", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/scoreOnlineExams/scoreExamView.html",
            controller: ["scoreOnlineExamResource", "messageService", "$timeout", "$state", ScoreExamCtrl],
            controllerAs: "vm"
        };
        function ScoreExamCtrl(scoreOnlineExamResource, messageService, $timeout, $state) {
            var vm = this;
            vm.dataLoaded = false;
            vm.attemptId = $state.params.attemptId;
            scoreOnlineExamResource.getScoreOnlineExamViewModel({ attemptId: vm.attemptId }, function (model) {
                vm.model = model;
                $timeout(function () {
                    vm.submitEnabled = vm.form.$valid && vm.model.status === "ProcessingResult";
                });
                vm.dataLoaded = true;
            });
            ////////////////////////////////////////////////////////////
            vm.saveScore = function (question, form) {
                vm.saving = true;
                //allow saving blank value - but main form should still be invalid
                if (form.$dirty) {
                    if (form.$valid || form.score.$error.required) {
                        var data = { Id: question.id, Score: question.score };
                        scoreOnlineExamResource.saveQuestionScore({ attemptId: vm.attemptId, questionNumber: question.number }, data, function () {
                            form.$setPristine();
                            vm.submitEnabled = vm.form.$valid;
                            $timeout(function () {
                                vm.saving = false;
                            }, 1500);
                            //messageService.success("exams.examQuestionForm.questionSaved");
                        }, function (error) {
                            messageService.error(error);
                            vm.submitEnabled = false;
                        });
                    }
                }
            };
            vm.saveComment = function (question) {
                vm.saving = true;
                var data = { Id: question.id, Comment: question.comment };
                scoreOnlineExamResource.saveQuestionComment({ attemptId: vm.attemptId, questionNumber: question.number }, data, function () {
                    $timeout(function () {
                        vm.saving = false;
                    }, 1500);
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.submitExam = function () {
                if (!vm.submitEnabled)
                    return;
                vm.submitEnabled = false;
                if (vm.form.$valid) {
                    scoreOnlineExamResource.submitManualMarkedExam({ attemptId: vm.attemptId }, {}, function (result) {
                        vm.model.finalScore = result.finalScore;
                        vm.model.status = result.status;
                        messageService.success("exams.scoreExam.examMarksSubmitted");
                    }, function (error) {
                        messageService.error(error);
                        vm.submitEnabled = true;
                    });
                }
                else {
                    messageService.error("common.exception.400.invalidModelState");
                    vm.submitEnabled = true;
                }
            };
        }
    });
}());
